import React, { useState } from 'react';

import { match } from '../../../utils/common.util';
import LoginWithEmail from './LoginWithEmail.form';
import LoginOTP from './LoginOTP.form';
import { APP_CONSTANT } from 'src/constants';


const LoginFormWrapper: React.FC = () => {
  const [stepLogin, setStepLogin] = useState<number>(1);
  const [verificationMethod, setVerificationMethod] = useState<string>(
    APP_CONSTANT.EMAIL
  );

  const handleRenderForm = () => {
    const pattern = {
      1: (
        <LoginWithEmail
          setStepLogin={setStepLogin}
          setVerificationMethod={setVerificationMethod}
        />
      ),
      2: <LoginOTP verificationMethod={verificationMethod} />,
      _: <div />
    };

    return match(pattern)(stepLogin);
  };

  return <>{handleRenderForm()}</>;
};

export default LoginFormWrapper;
